import { FormHelperText } from '@mui/material';
import React from 'react';

export default ({ error, errorText }) => {
  if (error && errorText && errorText.length) {
    return errorText.map((text) => (
      <FormHelperText key={text} error>
        {text}.
      </FormHelperText>
    ));
  }
  return null;
};
